<template>
    <div>
        <slot/>
    </div>
</template>

<script>
    export default {
        props: {
            disabled: {type: Boolean, default: false},
        },

        watch: {
            '$ui.offsetBottom'() {
                if (this.$ui.offsetBottom <= 150 && !this.disabled) {
                    this.$emit('fetch');
                }
            },
        },
    };
</script>